import React from 'react';
import { FormattedMessage } from 'react-intl';
import { v1 as uuid } from 'uuid';

import { ModalOverlayWrapper } from '../Styles';

const SearchBarHistoryOverlay = ({
  recentSearches = [],
  onHistoryItemClick = () => {}
}) => {
  const handleHistoryItemClick = recentSearch => () =>
    onHistoryItemClick(recentSearch);

  return (
    <ModalOverlayWrapper isSearchHistory>
      {recentSearches.length > 0 && (
        <ul>
          <li>
            <FormattedMessage id="list.nav.searchbar.modal.search.history" />
          </li>
          {recentSearches.map(recentSearch => (
            <li
              key={`recentSearch_${uuid()}`}
              role="presentation"
              onClick={handleHistoryItemClick(recentSearch)}
            >
              {recentSearch}
            </li>
          ))}
        </ul>
      )}
    </ModalOverlayWrapper>
  );
};

export default SearchBarHistoryOverlay;
